import jwtAxios from '@libs/services/auth/src/jwt-auth';
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getLocalStorage, LOCAL_STORAGE_NAMES } from '@libs/storage/src/lib/local';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.NX_API_URL,
  prepareHeaders: (headers) => {
    const token = getLocalStorage(LOCAL_STORAGE_NAMES.TOKEN);
    if (token) headers.set('Authorization', `Bearer ${token}`);

    const lang = getLocalStorage(LOCAL_STORAGE_NAMES.LANG);
    if (lang) headers.set('X-Language', lang);

    return headers;
  },
});

type axoiosBaseQueryProps = {
  url: string;
  method?: string;
  body?: any;
};

export const axiosBaseQuery = async (props: axoiosBaseQueryProps) => {
  const { url, method = 'GET', body } = props;

  try {
    const response = await jwtAxios({ url, method, data: body });
    // console.log('axiosBaseQuery = ', response);
    return {
      data: response.data,
      meta: { totalCount: Number(response.headers['x-total-count'] || 0) },
    };
  } catch (error) {
    return { error };
  }
};

export default baseQuery;
